module.exports = __webpack_public_path__ + "img/LMS Aset Banner Section.579adfc8.png";